"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Overview = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _variables = require("../../constants/variables");
var _useOverviewContext = require("../../hooks/useOverviewContext");
var _useTranslations = require("../../hooks/useTranslations");
var _OverviewContent = require("../OverviewContent");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const Overlay = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        background: (0, _mui.alpha)(theme.palette.common.black, 0.3),
        bottom: 0,
        boxSizing: 'border-box',
        left: 0,
        position: 'absolute',
        top: _variables.TOOLBAR_HEIGHT,
        width: '100%'
    };
});
const Overview = exports.Overview = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { isOverviewOpen, toggleOverviewOpen } = (0, _useOverviewContext.useOverviewContext)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Toggle, {
                "aria-label": "".concat(translations.singlePage, " / ").concat(translations.overview),
                checked: isOverviewOpen,
                "data-testid": getTestId(_constants.OVERVIEW_SWITCH),
                firstIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Editorial, {}),
                secondIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Dashboard, {}),
                title: "".concat(translations.singlePage, " / ").concat(translations.overview),
                onChange: toggleOverviewOpen
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Fade, {
                mountOnEnter: true,
                in: isOverviewOpen,
                timeout: 300,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Overlay, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OverviewContent.OverviewContent, {})
                })
            })
        ]
    });
});
